import actions from "./actions";
import { UsageType } from "../../containers/AppPage/ControlPanel/Subscription/QuotaSubscription/UsageType";

const initState = {
    quotas: [],
    readState: null,
    usersQuota: null,

    addonPacks: [],
    addonPacksReadState: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.READ_QUOTAS_REQUEST:
            return {
                ...state,
                readState: 'request',
            };

        case actions.READ_QUOTAS_SUCCESS: {
            return {
                ...state,
                readState: 'success',
                quotas: action.quotas,
            };
        }

        case actions.SET_STORAGE_QUOTA: {
            const newQuotas = state.quotas.filter(q => q.type !== UsageType.STORAGE);
            newQuotas.push(action.newStorageQuota);
            return {
                ...state,
                quotas: newQuotas,
            };
        }

        case actions.SET_USERS_QUOTA: {
            return {
                ...state,
                usersQuota: action.newUsersQuota,
            };
        }

        case actions.READ_ADD_ON_PACKS_REQUEST:
            return {
                ...state,
                addonPacksReadState: 'request',
            };
        case actions.READ_ADD_ON_PACKS_SUCCESS:
            return {
                ...state,
                addonPacksReadState: 'success',
                addonPacks: action.addonPacks,
                stateAddonPacks: action.addonPacks,
            };

        default:
            return state;
    }
}
